module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/theme/packages/core-app/src/templates/alertView.html -->\n<article class="content content--modal">\n	<p>'+
((__t=( msg ))==null?'':__t)+
'</p>\n</article>\n<footer class="footer footer--modal">\n	<div class="footer-actions footer-actions--right">\n		<button type="submit" class="mdc-button mdc-button--unelevated nx-save" data-nx-control="dismiss" data-i18n="i18n.ok">i18n.ok</button>\n	</div>\n</footer>\n';
}
return __p;
};
